import React from "react";

import styles from "./modal.module.scss";

const classNameRoot = styles["modal-head"];

const ModalHead = ({ className, ...restProps }) => {
  return (
    <div
      className={className ? (classNameRoot + " " + className) : classNameRoot}
      {...restProps}
    />
  );
};

export default ModalHead;
